__turbopack_context__.v({
  "active": "SearchResults-module__taunUG__active",
  "blok-big-title": "SearchResults-module__taunUG__blok-big-title",
  "blok-subtitle": "SearchResults-module__taunUG__blok-subtitle",
  "blok-title": "SearchResults-module__taunUG__blok-title",
  "headerText": "SearchResults-module__taunUG__headerText",
  "products": "SearchResults-module__taunUG__products",
  "searchResultsHeader": "SearchResults-module__taunUG__searchResultsHeader",
  "sentinel": "SearchResults-module__taunUG__sentinel",
});
